import { Route } from "react-router-dom";
import ClientSearchForm from "../components/index";

const ClientSearchFormRoutes = () => (
  <>
    <Route path="/search_form" element={<ClientSearchForm />} />
  </>
);


export default ClientSearchFormRoutes;